import { Navigate } from "@tanstack/react-router";
import { Flex, Text } from "styles/utility-components";

import QuickPromptsEditor from "components/ai_chat/quick_prompts/QuickPromptsEditor";
import { appRoutes } from "lib/appRoutes";
import { useSubscription } from "lib/hooks/subscription";
import { AiQuickPromptChatType } from "lib/types/graphQLEnums";
import { Content, Page } from "../workflow_stages/shared";

export default function QuickPromptsSettings(): JSX.Element {
  const { hasDataTypes } = useSubscription();

  // The bid response assistant is the only chat with quick prompts so far
  if (!hasDataTypes("BIDS")) {
    return <Navigate {...appRoutes.subscription} />;
  }

  return (
    <Page>
      <Content>
        <QuickPromptsEditor
          chatType={AiQuickPromptChatType.BidResponse}
          renderHeader={(actions) => (
            <Flex gap={16} alignItems="center" alignSelf="stretch">
              <Flex gap={8} column>
                <Text h1>Quick prompts</Text>
                <Text>
                  Quick prompts appear in the AI assistant when writing bid responses. Choosing one
                  puts it in the input, ready to edit and send. Changes apply to everyone in your
                  team.
                </Text>
              </Flex>
              <Flex gap={8} alignItems="center" flexShrink={0}>
                {actions}
              </Flex>
            </Flex>
          )}
        />
      </Content>
    </Page>
  );
}
